/* eslint-disable */
// Google Map set-up fucntions
const initMap = function( mapId, options, callback ) {
	if (!document.getElementById( mapId )) return;
  
	const defaults = {
		lat: Number(-37.7981804),
		lng: Number(145.4511941),
		style : [{"featureType":"water","elementType":"geometry","stylers":[{"color":"#e9e9e9"},{"lightness":17}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":20}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#ffffff"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":16}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":21}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#dedede"},{"lightness":21}]},{"elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"lightness":16}]},{"elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#333333"},{"lightness":40}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#f2f2f2"},{"lightness":19}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#fefefe"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#fefefe"},{"lightness":17},{"weight":1.2}]}],
		zoom : 14
	};
	if (!options) options = defaults;

	let location = {
		lat: Number(document.getElementById( mapId ).dataset.lat), 
		lng: Number(document.getElementById( mapId ).dataset.lng)
	};

	if ( !location.lat || !location.lng ) {
		location.lat = defaults.lat;
		location.lng = defaults.lng;
		console.warn( 'GMaps element did not have valid "data-lat" or "data-lng" attributes set, using default values...' );
	}
	var icon = {
			path: 'M36.5,0 C56.6398889,0 73,15.965 73,39.6153846 C73,70.2961795 51.4704074,92.7763256 36.5,103 C21.5295926,92.7765897 0,70.2961795 0,39.6153846 C0,15.965 16.3601111,0 36.5,0 Z M41.5587038,19.6666169 C41.0038909,19.2943587 40.2433847,19.4088612 39.8930347,19.93352 C39.5193373,20.3072173 39.0526613,21.0527733 37.4667413,22.5476 C31.0262747,28.6142667 28.3191413,35.8 27.2000747,40.6547333 C21.133408,41.21436 16.3738761,46.2528667 16.3738761,52.4142667 C16.3738761,58.9476 21.6929413,64.2666667 28.2262747,64.2666667 C31.2121947,64.2666667 33.9191413,63.1474133 35.9738747,61.3737067 C33.7335013,59.0403733 32.3335013,55.95944 32.3335013,52.5999067 C32.3335013,49.14732 33.8264613,46.0665733 36.1597947,43.73324 C34.479048,42.14732 32.2405413,41.11916 29.9073947,40.84028 C30.840728,37.1999067 32.8003547,32.1593467 36.5335947,27.49268 C36.2528667,30.9452667 36.907292,35.9855467 40.7335947,42.7069467 C36.8143413,44.4806533 34.1073947,48.3069467 34.1073947,52.69268 C34.1073947,58.8522133 39.4264613,63.7998143 45.9597947,63.7998143 C52.493128,63.7998143 57.6264613,58.66648 57.6264613,52.5998133 C57.6264613,46.5331467 52.3073947,41.3998133 45.7738,41.4 L45.7738,41.4 L45.3140193,41.4077559 C44.55776,41.4336228 43.8445378,41.5242624 43.06676,41.680728 C35.8810267,29.1735947 40.26676,23.3878613 40.35972,23.2949947 L40.35972,23.2949947 L41.85268,21.521288 L41.9336445,21.4132505 C42.3059026,20.8584376 42.1914001,20.0979313 41.6667413,19.7475813 Z M36.7197293,53.4400933 C37.4671427,52.9734267 38.8671427,53.8137907 39.893436,55.30676 C40.8267693,56.89268 41.0145093,58.4804667 40.2671333,58.9471333 C39.51972,59.4138 38.11972,58.573436 37.0934267,57.0804667 C36.1600933,55.5875067 35.9741733,53.90676 36.7197293,53.4400933 Z M20.1054533,47.0928667 C21.3195333,45.7858267 22.9984133,45.2262 23.8387867,46.0665733 C24.68098,46.9069467 24.4002333,48.5858267 23.1862,49.8928667 C21.97212,51.1999067 20.29324,51.7595333 19.4528667,50.91916 C18.6124933,50.1717467 18.89324,48.4928667 20.1054533,47.0928667 Z M45.30732,24.5996173 C43.71958,23.759244 41.8529133,24.3188893 41.01436,25.252204 C42.9738933,25.6260973 45.2142667,27.3049867 46.7071333,28.7998133 C45.4930533,28.1472267 44.28084,27.5857333 42.9738,27.3068533 C42.3212133,27.1209147 41.66676,27.0261253 41.1071333,27.1209147 C40.8264053,27.1209147 40.5475067,27.1209147 40.26676,27.213884 C40.3597293,28.2401773 40.7334267,29.6401773 42.2263867,30.4805507 C44.9334267,31.8805507 50.15972,30.9472173 50.15972,30.9472173 C50.15972,30.9472173 48.0141267,25.9996173 45.30732,24.5996173',
			fillColor: "#AE0219",
      fillOpacity: 1,
      strokeWeight: 0
	};
	var svgIcon = {
		path: 'M10,26 C3.33333333,19.0152317 0,13.6818983 0,10 C0,4.4771525 4.4771525,0 10,0 C15.5228475,0 20,4.4771525 20,10 C20,13.6818983 16.6666667,19.0152317 10,26 Z M10,14 C12.209139,14 14,12.209139 14,10 C14,7.790861 12.209139,6 10,6 C7.790861,6 6,7.790861 6,10 C6,12.209139 7.790861,14 10,14 Z',
		fillColor: '#fa0000',
		anchor: new google.maps.Point( 10, 26 ),
		fillOpacity: 1,
		strokeWeight: 0,
		scale: 1
	};
	var map = new google.maps.Map(document.getElementById( mapId ), {
		zoom: options.zoom || defaults.zoom,
		zoomControl: 				false,
		mapTypeControl: 		false,
		scaleControl: 			false,
		streetViewControl: 	false,
		rotateControl: 			false,
		fullscreenControl: 	false,
		center: location,
		styles: options.style || defaults.style
	});
	
	var marker = new google.maps.Marker({
		position: location,
		map: map,
		icon: icon
	});

  marker.addListener( 'click', () => {
    console.log( defaults )
    window.open( 
      `https://www.google.com/maps/search/?api=1&query=CherryHill%20Orchards`, 
      '_blank' 
    );
  });

	callback( map );
}

// Handle loading of GMaps script
const loadScript = function(url, completeCallback) {
	var script = document.createElement('script'), done = false,
			head = document.getElementsByTagName("head")[0];
	script.src = url;
	script.onload = script.onreadystatechange = function(){
		if ( !done && (!this.readyState ||
				this.readyState == "loaded" || this.readyState == "complete") ) {
			done = true;
			if (completeCallback) completeCallback();
			// IE memory leak
			script.onload = script.onreadystatechange = null;
			head.removeChild( script );
		}
	};
	head.appendChild(script);
}

// Set up Maps
const setupGoogleMapsApi = function( mapsArray, options ) {
	const mapEl = document.getElementById( mapsArray[0] );
	if ( mapEl ) {
		if (typeof google === 'object' && typeof google.maps === 'object') {
      processMaps( mapsArray, options );
    } else {
      loadScript( 
        'https://maps.googleapis.com/maps/api/js?key=AIzaSyD9eYHXJojS0fFksCNrjUaSrlzYXOxs9rI', 
        function() { processMaps( mapsArray, options ) }
      );
    }
	}
}

// Pan Map
const panMap = function( mapId, options ) {
	initMap( mapId, options, function( map ) { 
    map.panBy(0, 50) ;
  } )
}

// Process Maps
const processMaps = function( mapsArray, options ) {
	if ( !Array.isArray( mapsArray ) ) return console.error( 'Need to pass an array if Google Map IDs' );
	mapsArray.forEach( m => {
		panMap( m, options );
	});
}

module.exports = { 
	setupGoogleMapsApi 
}